import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    ENVIRONMENT_INITIALIZER,
    EnvironmentProviders,
    inject,
    Provider,
} from '@angular/core';
import { dateInterceptor } from './date.interceptor';
import { MetadataService } from '../metadata/metadata.service';

export const provideDates = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([dateInterceptor])),
        {
            provide: ENVIRONMENT_INITIALIZER,
            useValue: () => inject(MetadataService),
            multi: true,
        },
    ];
};
